import { IPaidFeature, PaidFeatureEnum } from "@evennt-tech/api-v2-core";

export type GeneralData = {
  lastExhibitorInvoiceId: string;
  lastOrganiserMonthlyInvoiceId: string;
  lastSupplierMonthlyInvoiceId: string;
  exhibitorTemplate: { [k: string]: string[] };
};

export type ProStoragePlanName =
  | PaidFeatureEnum.PRO_STORAGE_BASIC
  | PaidFeatureEnum.PRO_STORAGE_MEDIUM
  | PaidFeatureEnum.PRO_STORAGE_LIMITLESS;

export const proStoragePlans = [
  PaidFeatureEnum.PRO_STORAGE_BASIC,
  PaidFeatureEnum.PRO_STORAGE_MEDIUM,
  PaidFeatureEnum.PRO_STORAGE_LIMITLESS,
];

export type ProStoragePlan = IPaidFeature & { name: ProStoragePlanName };

export type MaintenanceMode = {
  enabled: boolean;
  description: string;
  descriptionTranslations?: Record<string, string>;
  showNotification?: boolean;
};
